import React from 'react';
import { Polygon as BPolygon} from '@uiw/react-baidu-map'
import { Polygon as APolygon } from '@uiw/react-amap';
import { MAP_TYPE, MAP_TYPES } from '@helpers/Constants';
import { IMapPoint } from '../types';

interface PolygonOptionProps {
  strokeColor?: string;
  strokeStyle?: string;
  strokeOpacity?: number;
  fillColor?: string;
  fillOpacity?: number;
  extData?: any;
  path: IMapPoint[];
  zIndex?: number;
  enableEditing?: boolean;
  enableMassClear?: boolean;
  enableClicking?: boolean;
}

const dataAdapter = (type: string, data: PolygonOptionProps) => {
  let polygonData: any = data;
  switch(type) {
    case MAP_TYPES.aMap:
      polygonData = {
        ...polygonData,
        path: polygonData.path.map((i:IMapPoint ) => [i.lng, i.lat])
      }  as any
      break;
    //no default;

  }
  return polygonData
}

const Polygon = (props: PolygonOptionProps) => {
  console.log(props, 'props');
  const content = {
    [MAP_TYPES.aMap]: APolygon,
    [MAP_TYPES.bMap]: BPolygon
  }

  const Content = content[MAP_TYPE] || null;
  const data: any = dataAdapter(MAP_TYPE, props);
  if(Content) {
    return <Content {...data } />
  }
  return null
}

export default Polygon;
